import { Entity } from "../../Entity";
import TransactionFileFactory from "../../Factories/TransactionFileFactory";
import { FactoryInterface } from "../../FactoryInterface";
import { TransactionFileInterface } from "./TransactionFileInterface";
import { PersonInterface } from "../Person/PersonInterface";
import { StatusInterface } from "./Status/StatusInterface";

class TransactionFile extends Entity implements TransactionFileInterface {

  constructor(public data) {
    super();
  }

  public getFactory(): FactoryInterface {
    return TransactionFileFactory;
  }

  get id(): number {
    return this.data.id;
  }

  get name(): string {
    return this.data.name;
  }

  get path(): string {
    return this.data.path;
  }

  get createdAt(): Date {
    return this.data.createdAt;
  }

  get creator(): PersonInterface {
    return this.relation("app.persons", this.data.createdBy)[0];
  }

  get createdBy(): number {
    return this.data.createdBy;
  }

  get statusId(): number {
    return this.data.statusId;
  }

  get status(): StatusInterface {
    return this.data.status;
  }

  get reason(): string {
    return this.data.reason;
  }

  get removed(): boolean {
    return this.data.removed;
  }

  get processedPaymentIds(): number[] {
    return this.data.processedPaymentIds;
  }

  get payments(): any[] {
    return this.data.payments;
  }

  get description(): string {
    return this.data.description;
  }

  get oldestTransactionDate(): Date {
    return this.data.oldestTransactionDate;
  }

  get newestTransactionDate(): Date {
    return this.data.newestTransactionDate;
  }
}

export { TransactionFile }
